import React from 'react';
import { withStyles } from 'tss-react/mui';
import Fab from '@mui/material/Fab';
import { Close, Done } from '@mui/icons-material';
import green from '@mui/material/colors/green';
import { DOCVAL, DOCREF } from '@lba-dev/package.local-globals/docStatus';

import stopPropagation from '../../utils/stopPropagation';

const styles = {
  container: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    '& .MuiFab-root': {
      width: 32,
      height: 32,
      minHeight: 32,
      '& .MuiSvgIcon-root': {
        fontSize: '1.25rem'
      }
    },
    marginLeft: '10px'
  }
};


const ValidationButton = ({ classes, sendStatus, fileName, docType }) => (
  <div className={classes.container}>
    <Fab
      size="small"
      color="primary"
      style={{ backgroundColor: green[500] }}
      onClick={stopPropagation(() => sendStatus(fileName, DOCVAL, docType))}
    >
      <Done />
    </Fab>
    <Fab
      size="small"
      color="secondary"
      style={{ minHeight: 32 }}
      onClick={stopPropagation(() => sendStatus(fileName, DOCREF, docType))}
    >
      <Close />
    </Fab>
  </div>
);

export default withStyles(ValidationButton, styles);

